import { render, staticRenderFns } from "./ReferralDetails.vue?vue&type=template&id=63b64f40&"
import script from "./ReferralDetails.vue?vue&type=script&lang=ts&"
export * from "./ReferralDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralDetails.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports